import './index.scss';
import dayjs from 'dayjs';
import Header from '../../../../../../../components/Header/Header';
import QuickActions from '../../../../../../../components/QuickActions';
import failureIcon from '../../../../../../../assets/icons/failureIcon.svg';
import successIcon from '../../../../../../../assets/icons/succesIcon.svg';
import chevronTable from '../../../../../../../assets/icons/chevronTable.svg';
import NoData from '../../../../../../../components/NoData/NoData';
import { useEffect, useState } from 'react';
import useTargetSavings from '../../../../../../../hooks/useTargetSavings';
import { useParams } from 'react-router-dom';
import { copyToClipboard, formatToNaira } from '../../../../../../../helpers/utils';
import { formatDate } from '../../../../../../../helpers/utils/date';
import { IoCopyOutline } from 'react-icons/io5';
import { Loader } from '@piggytechng/component-library';
import { HiOutlineLockClosed } from 'react-icons/hi';
import { FiUnlock } from 'react-icons/fi';
import TransactionDetailsAlt from '../../../../../../../components/NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import ModalTransactionSearch from '../../../../../../../components/Modals/ModalTransactionSearch';
import InterestBreakdown from '../../../../../../../components/InterestBreakdown/InterestBreakdown';
import { AppliedTransactionSearch } from '../../../../../../../types';

const index = () => {
  const {
    fetchTargetSavingsSettings,
    fetchTargetSavingsTransactions,
    searchTargetSavingsTransactions,
    fetchingSettings,
    fetchingTransactions,
    targetSavingsTransactions,
    targetSavingsSettings,
  } = useTargetSavings();

  const params = useParams();
  const userId = params.id as string;
  const targetId = params.targetId as string;
  const [show, setShow] = useState(false);
  const [trDetails, setTrDetails] = useState({});
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [appliedSearch, setAppliedSearch] = useState<AppliedTransactionSearch | null>(null);
  const [activeHistoryTab, setActiveHistoryTab] = useState<'wallet' | 'interest'>('wallet');

  const handleApplySearch = (_filter: string, value: string, display: string) => {
    setAppliedSearch({ filter: '', query: value, display });
    searchTargetSavingsTransactions(userId, targetId, value, 1, 20);
    setShowSearchModal(false);
  };

  const handleResetSearch = () => {
    setAppliedSearch(null);
    fetchTargetSavingsTransactions(userId, targetId, 1, 20);
  };

  const handleShowTransactionsDetails = (data: any) => {
    setTrDetails(data);

    setShow(true);
  };

  useEffect(() => {
    fetchTargetSavingsSettings(userId, targetId);
    fetchTargetSavingsTransactions(userId, targetId, 1, 20);
  }, []);

  console.log('targetSavingsTransactions', targetSavingsTransactions);

  return (
    <div className="single-target-page">
      <Header name="Single Target" backButton />

      {fetchingSettings || fetchingTransactions ? (
        <div className="page-loader">
          <Loader color="#00896b" />
        </div>
      ) : (
        <>
          <div className="content">
            <div className="target-header">
              <div className="left-section">
                <h1>
                  {targetSavingsSettings?.name}.{' '}
                  <span>
                    {targetSavingsSettings?.targetStatus === 0 ? 'Active' : 'Completed'}
                    {targetSavingsSettings?.isLocked ? <HiOutlineLockClosed size={20} /> : <FiUnlock size={15} />}
                  </span>
                </h1>
                <span className="flex--2 cont">
                  <p>Target ID: {targetId} </p>
                  <IoCopyOutline
                    size={18}
                    className="pointer"
                    onClick={() => copyToClipboard('Target ID', targetId)}
                  />{' '}
                </span>
              </div>
              <div className="right-section">
                <QuickActions
                  activeTabWallet="target"
                  targetStatus={targetSavingsSettings?.targetStatus}
                  targetId={targetId}
                  userId={targetSavingsSettings?.userId}
                  isWalletTab={false}
                />
              </div>
            </div>
            <div className="target-details">
              {targetSavingsSettings && (
                <>
                  <div className="detail">
                    <p>Intended Target</p>
                    <h1>{formatToNaira(targetSavingsSettings?.targetAmount)}</h1>
                  </div>
                  <div className="detail">
                    <p>Balance</p>
                    <h1>
                      {targetSavingsTransactions?.length ? targetSavingsTransactions[0]?.balance : formatToNaira(0)}
                    </h1>
                  </div>
                  <div className="detail">
                    <p>Frequency</p>
                    <h1>
                      {' '}
                      {formatToNaira(targetSavingsSettings?.amount ?? 0)} {targetSavingsSettings?.frequency}
                    </h1>
                  </div>
                  <div className="detail">
                    <p>Start Date</p>
                    <h1>{formatDate(targetSavingsSettings.startDate).readableDate}</h1>
                  </div>
                  <div className="detail">
                    <p>End Date</p>
                    <h1>{formatDate(targetSavingsSettings!.endDate).readableDate}</h1>
                  </div>
                  <div className="detail">
                    <p>Last Transaction Date</p>
                    <h1>
                      {targetSavingsSettings!.lastTransactionDate === 0
                        ? 'None'
                        : formatDate(targetSavingsSettings!.lastTransactionDate).readableDate}
                    </h1>
                  </div>
                </>
              )}
            </div>

            <div className="history-tab-switch target">
              <span
                className={`history-pill${activeHistoryTab === 'wallet' ? ' active' : ''}`}
                onClick={() => setActiveHistoryTab('wallet')}
              >
                Target History
              </span>
              <span
                className={`history-pill${activeHistoryTab === 'interest' ? ' active' : ''}`}
                onClick={() => setActiveHistoryTab('interest')}
              >
                Interest Breakdown
              </span>
            </div>

            {activeHistoryTab === 'interest' ? (
              <InterestBreakdown walletName="target" targetId={targetId} loaderColor="#00896b" />
            ) : (
              <>
                <div className="customers-filter">
                  <div className="input-field">
                    <form action="" onSubmit={(e) => e.preventDefault()}>
                      <input
                        type="text"
                        readOnly
                        placeholder="Search by reference, amount, memo, date"
                        value={appliedSearch ? appliedSearch.display : ''}
                        onClick={() => setShowSearchModal(true)}
                      />
                    </form>
                  </div>
                  <div className="query-filter" onClick={() => setShowSearchModal(true)}>
                    <div>
                      <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                          stroke="#1E293B"
                          strokeWidth="1.5"
                          strokeLinecap="square"
                        />
                      </svg>
                    </div>
                    <div>Search</div>
                  </div>
                  <div className="query-filter" onClick={handleResetSearch}>
                    <div></div>
                    <div>Reset</div>
                  </div>
                </div>

                {targetSavingsTransactions?.length ? (
                  <div className="table-container housemoney">
                    <table className="table">
                      <thead className="table_head">
                        <tr>
                          <th className="icon">{''}</th>
                          <th className="date">Date</th>
                          <th className="amount">{`Amount (₦)`}</th>
                          <th className="">{`Balance (₦)`}</th>
                          <th className="memo">Memo</th>
                          <th className="transactionID">Transaction ID</th>
                        </tr>
                      </thead>

                      <tbody className="table-body">
                        {targetSavingsTransactions.map((txn: any, index: any) => (
                          <tr key={index} className="table-row" onClick={() => handleShowTransactionsDetails(txn)}>
                            <img src={txn?.rawAmount[0] === '+' ? successIcon : failureIcon} />
                            <td>{dayjs(txn.created_at).format('D MMM YYYY | h:mm A')}</td>
                            <td>{txn.rawAmount}</td>
                            <td>{txn.balance}</td>
                            <td className="memo">{txn.description}</td>
                            <td>{txn.id}</td>
                            <img className="chevron-table" src={chevronTable} />
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <NoData message={'No transaction at the moment.'} />
                )}
              </>
            )}
          </div>
        </>
      )}

      <TransactionDetailsAlt
        show={show}
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />

      <ModalTransactionSearch
        modalIsOpen={showSearchModal}
        setIsOpen={setShowSearchModal}
        hasCriteria={false}
        onApply={handleApplySearch}
        onClear={handleResetSearch}
        isLoading={fetchingTransactions}
        initialQuery={appliedSearch?.query}
      />
    </div>
  );
};

export default index;
